export default {
    black: {
        '--C_129': '#777',
        '--C_171': '#000',
        '--C_174': '#3d3d3d',
        '--C_175': '#454545 0, #383838 100%',
        '--C_176': '#454545 0, #383838 100%',
        '--C_177': '#454545 0, #383838 100%',
        '--C_178': '#454545 0, #383838 100%',
        '--C_180': 'startColorstr=#454545, endColorstr=#383838, GradientType=0',
        '--C_181': '#fff',
        '--C_184': '#666',
        '--C_185': '#fff',
        '--C_191': '#fff',
        '--C_196': '#000',
        '--C_198': '#555',
        '--C_199': '#fff',
        '--C_357': '#666',
        '--C_358': '#000',
        '--C_361': '#3d3d3d',
        '--C_365': '#0052A3',
        '--C_368': '#fff',
        '--C_371': '#3d3d3d',
        '--C_374': '#666',
        '--C_378': '#000',
        '--C_390': '#3d3d3d',
        '--C_393': '#666',
        '--C_397': '#000',
        '--C_409': '#3d3d3d',
        '--C_412': '#666',
        '--C_416': '#000',
        '--C_481': '#777',
        '--C_482': '#787878',
        '--C_483': '#787878',
        '--C_484': '#787878',
        '--C_489': '#000',
        '--C_492': '#3d3d3d',
        '--C_493': '#454545 0, #383838 20%',
        '--C_494': '#454545 0, #383838 20%',
        '--C_495': '#454545 0, #383838 20%',
        '--C_496': '#454545 0, #383838 20%',
        '--C_498': 'startColorstr=#454545, endColorstr=#383838, GradientType=0',
        '--C_501': '#000',
        '--C_505': '#000',
        '--C_508': '#000',
        '--C_616': '#444',
        '--C_617': '#777',
        '--C_631': '#555',
        '--C_636': '#000 #000 #222 #000',
        '--C_639': '#222 #000 #000 #000',
        '--C_644': '#555',
        '--C_654': '#777',
        '--C_802': '#fff',
        '--C_803': '#777',
        '--C_805': '#555',
        '--C_806': '#919191 0, #6a6a6a 100%',
        '--C_807': '#919191 0, #6a6a6a 100%',
        '--C_808': '#919191 0, #6a6a6a 100%',
        '--C_809': '#919191 0, #6a6a6a 100%',
        '--C_811': 'startColorstr=#919191, endColorstr=#6a6a6a, GradientType=0',
        '--C_817': '#777',
        '--C_818': '#fff',
        '--C_819': '#555',
        '--C_829': '#555',
        '--C_833': '#777',
        '--C_834': '#fff',
        '--C_835': '#555',
        '--C_844': '#777',
        '--C_845': '#fff',
        '--C_846': '#919191 0, #6a6a6a 100%',
        '--C_847': '#919191 0, #6a6a6a 100%',
        '--C_848': '#919191 0, #6a6a6a 100%',
        '--C_849': '#919191 0, #6a6a6a 100%',
        '--C_851': 'startColorstr=#919191, endColorstr=#6a6a6a, GradientType=0',
        '--C_864': '#000',
        '--C_869': '#000',
        '--C_873': '#000',
        '--C_1014': '#000000',
        '--C_1015': '#000',
        '--C_1016': '#000',
        '--C_1017': '#000',
        '--C_1091': '#666',
        '--C_1094': '#3d3d3d',
        '--C_1097': '#777',
        '--C_1100': '#777',
        '--C_1131': '#777',
        '--C_1132': '#fff',
        '--C_1135': '#0052A3',
        '--C_1136': '#fff',
        '--C_1162': '#777',
        '--C_1163': '#777',
        '--C_1319': '#cccccc',
        '--C_1322': '#444',
        '--C_1325': '#444',
        '--C_1328': '#444',
        '--C_1331': '#444',
        '--C_1334': '#3d3d3d',
        '--C_1337': '#3d3d3d',
        '--C_1654': '#3d3d3d',
        '--C_1657': '#3d3d3d',
        '--C_1663': '#777',
        '--C_1664': '#fff',
        '--C_1668': '#666',
        '--C_1669': '#fff',
        '--C_1670': '#454545 0, #666 100%',
        '--C_1671': '#454545 0, #666 100%',
        '--C_1672': '#454545 0, #666 100%',
        '--C_1673': '#454545 0, #666 100%',
        '--C_1675': 'startColorstr=#454545, endColorstr=#666, GradientType=0',
        '--C_1678': '#666 0, #454545 100%',
        '--C_1679': '#666 0, #454545 100%',
        '--C_1680': '#666 0, #454545 100%',
        '--C_1681': '#666 0, #454545 100%',
        '--C_1683': 'startColorstr=#666, endColorstr=#454545, GradientType=0',
        '--C_1686': '#454545 0, #666 100%',
        '--C_1687': '#454545 0, #666 100%',
        '--C_1688': '#454545 0, #666 100%',
        '--C_1689': '#454545 0, #666 100%',
        '--C_1691': 'startColorstr=#454545, endColorstr=#666, GradientType=1',
        '--C_1694': '#666 0, #454545 100%',
        '--C_1695': '#666 0, #454545 100%',
        '--C_1696': '#666 0, #454545 100%',
        '--C_1697': '#666 0, #454545 100%',
        '--C_1699': 'startColorstr=#666, endColorstr=#454545, GradientType=1',
        '--C_1702': '#fff',
        '--C_1703': '#3d3d3d',
        '--C_1704': '#454545 0, #383838 100%',
        '--C_1705': '#454545 0, #383838 100%',
        '--C_1706': '#454545 0, #383838 100%',
        '--C_1707': '#454545 0, #383838 100%',
        '--C_1709': 'startColorstr=#454545, endColorstr=#383838, GradientType=0',
        '--C_1713': '#3d3d3d',
        '--C_1729': '#000',
        '--C_1734': '#777',
        '--C_1737': '#666',
        '--C_1740': '#666',
        '--C_1743': '#666',
        '--C_1746': '#666',
        '--C_1749': '#0052A3',
        '--C_1750': '#fff',
        '--C_1752': '#000',
        '--C_1817': '#444',
        '--C_1818': '#777',
        '--C_1946': '#000',
        '--C_1978': '#666',
        '--C_1982': '#444',
        '--C_1983': '#4c4c4c 0, #3f3f3f 100%',
        '--C_1984': '#4c4c4c 0, #3f3f3f 100%',
        '--C_1985': '#4c4c4c 0, #3f3f3f 100%',
        '--C_1986': '#4c4c4c 0, #3f3f3f 100%',
        '--C_1988': 'startColorstr=#4c4c4c, endColorstr=#3f3f3f, GradientType=0',
        '--C_1991': '#fff',
        '--C_1994': '#cccccc',
        '--C_1997': '#000',
        '--C_2000': '#000',
        '--C_2004': '#555',
        '--C_2010': '#222',
        '--C_2015': '#222',
        '--C_2020': '#fff',
        '--C_2024': '#555',
        '--C_2028': '#777',
        '--C_2029': '#fff',
        '--C_2033': '#0052A3',
        '--C_2034': '#fff',
        '--C_2051': '#00458a',
        '--C_2054': '#00458a',
        '--C_2072': '#222',
        '--C_2075': '#3d3d3d',
        '--C_2078': '#222',
        '--C_2084': '#3d3d3d',
        '--C_2095': '#444',
        '--C_2098': '#222',
        '--C_2135': '#fff',
        '--C_2172': '#222',
        '--C_2175': '#777',
        '--C_2176': '#fff',
        '--C_2195': '#444',
        '--C_2196': '#777',
        '--C_2256': '#000',
        '--C_2415': '#ffffff',
        '--C_2418': '#fff',
        '--C_2430': '#000',
        '--C_2433': '#000',
        '--C_2436': '#3d3d3d',
        '--C_2440': '#666',
        '--C_2443': '#555',
        '--C_2449': '#777',
        '--C_2450': '#fff',
        '--C_2453': '#555',
        '--C_2457': '#0052A3',
        '--C_2458': '#fff',
        '--C_2459': '#00458a',
        '--C_2463': '#3d3d3d',
        '--C_2502': '#555',
        '--C_2505': '#fff',
        '--C_2521': '#3d3d3d',
        '--C_2533': '#fff',
        '--C_2535': '#3d3d3d',
        '--C_2578': '#777',
        '--C_2590': '#777',
        '--C_2600': '#3d3d3d',
        '--C_2609': '#3d3d3d',
        '--C_2613': '#3d3d3d',
        '--C_2643': '#000',
        '--C_2646': '#fff',
        '--C_2651': '#0052A3',
        '--C_2652': '#fff',
        '--C_2708': '#3d3d3d',
        '--C_2807': '#000',
        '--C_2808': '#3d3d3d',
        '--C_2811': '#000',
        '--C_2814': '#fff',
        '--C_2896': '#777',
        '--C_2897': '#787878',
        '--C_2898': '#787878',
        '--C_2899': '#787878',
        '--C_2906': '#444',
        '--C_2907': '#777',
        '--C_2910': '#444',
        '--C_2911': '#777',
        '--C_2914': '#666',
        '--C_2915': '#444',
        '--C_2916': '#fff',
        '--C_2919': '#666',
        '--C_2923': '#666',
        '--C_2926': '#555',
        '--C_2927': '#fff',
        '--C_2928': '#777',
        '--C_2933': '#fff',
        '--C_2948': '#777',
        '--C_2949': '#fff',
        '--C_2950': '#555',
        '--C_3002': '#cccccc',
        '--C_3025': '#555',
        '--C_3026': '#777',
        '--C_3027': '#fff',
        '--C_3038': '#cccccc',
        '--C_3080': '#000',
        '--C_3086': '#777',
        '--C_3251': '#000',
        '--C_3264': '#666',
        '--C_3265': '#fff',
        '--C_3266': '#000',
        '--C_3269': '#777',
        '--C_3270': '#fff',
        '--C_3273': '#0052A3',
        '--C_3274': '#fff',
        '--C_3369': '#666',
        '--C_3370': '#000',
        '--C_3371': '#fff',
        '--C_3374': '#000',
        '--C_3377': '#666',
        '--C_3380': '#000',
        '--C_3383': '#666',
        '--C_3386': '#000',
        '--C_3389': '#666',
        '--C_3392': '#000',
        '--C_3395': '#666',
        '--C_3405': '#555',
        '--C_3406': '#555',
        '--C_3431': '#0052A3',
        '--C_3432': '#fff',
        '--C_3435': '#666',
        '--C_3436': '#fff',
        '--C_3454': '#666',
        '--C_3455': '#fff',
        '--C_3456': '#555',
        '--C_3457': '#555',
        '--C_3458': '#555',
        '--C_3459': '#555',
        '--C_3475': '#555',
        '--C_3476': '#555',
        '--C_3477': '#555',
        '--C_3482': '#00458a',
        '--C_3491': '#00458a',
        '--C_3507': '#00458a',
        '--C_3514': '#00458a',
        '--C_3549': '#fff',
        '--C_3554': '#fff',
        '--C_3557': '#777',
        '--C_3558': '#fff',
        '--C_3561': '#777',
        '--C_3562': '#fff',
        '--C_3565': '#00458a',
        '--C_3566': '#fff',
        '--C_3567': '#0052A3',
        '--C_3619': '#3d3d3d',
        '--C_3620': '#fff',
        '--C_3640': '#00458a',
        '--C_3641': '#fff',
        '--C_3654': '#00458a',
        '--C_3661': '#00458a',
        '--C_3665': '#fff',
        '--C_3675': '#00458a'
    }
}